/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { EnableSidebar, PageTitle } from '../../../../_metronic/layout/core'
import { Questions } from '../dev/components/partials/Questions'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { KTSVG } from '../../../../_metronic/helpers'
import { Link } from 'react-router-dom'
import { Publications } from '../dev/components/partials/Publications'
import { useAuth } from '../../auth'
var CryptoJS = require("crypto-js");

function decrypt() {
  const key = CryptoJS.SHA256('arts-tu').toString(CryptoJS.enc.Hex);
  const method = 'AES-256-CBC';
  const encrypted = 'lY3bLLytUXI5acx+q21JeRaO2C7IAJP1II6tgPd0Qt8=';

  const encryptedData = CryptoJS.enc.Base64.parse(encrypted);
  const ivSize = CryptoJS.algo[method.toUpperCase()].blockSize * 4;
  const iv = encryptedData.words.slice(0, ivSize/4);
  const data = encryptedData.words.slice(ivSize/4);

  const decrypted = CryptoJS.AES.decrypt({
    ciphertext: CryptoJS.lib.WordArray.create(data)
  }, CryptoJS.enc.Hex.parse(key), {
    iv: CryptoJS.lib.WordArray.create(iv),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  return decrypted.toString(CryptoJS.enc.Utf8);
}

const PersonalPublication: FC = () => {
  const { currentUser } = useAuth()
  //decrypt()
  // const intl = useIntl()
  return (
    <EnableSidebar>
      <div className='d-flex flex-stack flex-wrap'>
        <div className='d-flex align-items-center py-1'>
          {currentUser && <h1 className='fs-2x fw-bolder text-gray-900 mb-5 me-1'>
            ผลงานของคุณ
          </h1>}

          {!currentUser && <h2 className='fs-2x fw-bolder text-gray-900 mb-5 me-1'>
            กรุณา login เข้าสู่ระบบเพื่อดูผลงานของคุณ
          </h2>}
        </div>

        <div className='d-flex align-items-center py-1'>
          {currentUser && <Link
            to='/personal_publication/publication_add'
            className='btn btn-sm btn-outline btn-outline-dashed btn-info px-4 me-2'
          >
            เพิ่มผลงานใหม่ <i className="ms-1 bi bi-plus-circle"></i>
          </Link>}

        </div>
      </div>



      <Publications />
    </EnableSidebar>
  )
}

export { PersonalPublication }
